import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Header as BarteHeader, DrawerList, ActionDrawerItems, Icon } from 'barte-design-system';
import { getDrawerItems } from './header.constants';

export const Header = () => {
    const { t } = useTranslation();

    const companyName = localStorage.getItem('companyName') ?? '';
    const email = localStorage.getItem('userEmail') ?? '';

    const drawerItems = useMemo(() => getDrawerItems(t, email), [t, email]);

    return (
        <BarteHeader
            variant="payfac"
            pillsLabel={companyName}

            avatarProps={{
                variant: 'icon',
                size: 'lg',
                color: 'inverse'
            }}
            avatarDrawerContent={
                <DrawerList>
                    <ActionDrawerItems
                        title={email}
                        items={drawerItems.map((item, index) => ({
                            ...item,
                            key: index.toString(),
                            icon: <Icon icon={item.icon} />,
                            onClick: () => {
                                if (item.link) {
                                    window.location.href = item.link;
                                }
                            }
                        }))}
                    />
                </DrawerList>
            }
        />
    );
};
